import React, { PureComponent } from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import styles from "./VisualitzacioLiniaTemporal.module.css";
import VisualitzacioLiniaTemporalData from "./VisualitzacioLiniaTemporalData";
import VisualitzacioLiniaTemporalControls from "./VisualitzacioLiniaTemporalControls";
import Titol from "./VisualitzacioTitol";
import { getTipusActiu } from "../../reducers";
import { MAPA } from "../../constantsFormularis";

import {
  getVisibilitatObservacions,
  getDataInici,
  getDataFi,
  getDataSeleccionada
} from "../../reducers";
import { MASCARA_DDMMYYYY } from "../../utils/dates";

import { omplirDataSeleccionadaVisualitzacio } from "../../actions";
class VisualitzacioLineaTemporal extends PureComponent {
  visualitzarControls() {
    const { observacions, tipusActiu } = this.props;
    const visualitzar =
      tipusActiu === MAPA &&
      Array.isArray(observacions) &&
      observacions.length > 0;

    return visualitzar;
  }

  render() {
    const { dataSeleccionada, observacions } = this.props;
    const primeraDataAmbDada =
      Array.isArray(observacions) && observacions.length > 0
        ? observacions[0].dataObservacio
        : "";
    const dataTitulo = dataSeleccionada
      ? dataSeleccionada
      : primeraDataAmbDada
      ? primeraDataAmbDada
      : null;

    const dataTituloFormat = moment(dataTitulo).format(MASCARA_DDMMYYYY);

    return (
      <div>
        {this.visualitzarControls() ? (
          <div className={styles.MenuLiniaTemporal}>
            <div className={styles.MenuLiniaTemporal_Titol}>
              <Titol>Resum Diari d'observacions</Titol>
            </div>
            <div className={styles.MenuLiniaTemporal_Data}>
              <VisualitzacioLiniaTemporalData data={dataTituloFormat} />
            </div>
            <div className={styles.MenuLiniaTemporal_Controls}>
              <VisualitzacioLiniaTemporalControls />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

VisualitzacioLineaTemporal.propTypes = {
  observacions: PropTypes.array,
  dataInici: PropTypes.string,
  dataFi: PropTypes.string,
  dataSeleccionada: PropTypes.string,
  tipusActiu: PropTypes.string
};

const mapStateToProps = state => ({
  dataInici: getDataInici(state),
  dataFi: getDataFi(state),
  dataSeleccionada: getDataSeleccionada(state),
  observacions: getVisibilitatObservacions(state),
  tipusActiu: getTipusActiu(state)
});

export default connect(mapStateToProps, {
  omplirDataSeleccionadaVisualitzacio
})(VisualitzacioLineaTemporal);
